import Config from "../../utils/Config";
import axios from "axios";
const BASE_URL = Config.baseUrl;

class LoginRequests {
  constructor() {
    this.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }

  async login(payload) {
    try {
      const response = await axios.post(`${BASE_URL}api/user/login`, payload, {
        headers: this.headers,
      });
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  async sendPasswordResetEmail(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}api/user/email/resetpassword`,
        payload,
        {
          headers: this.headers,
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  async resetPassword(payload){
    try{
      const response = await axios.post(`${BASE_URL}api/user/resetpassword`, payload, {
        headers: this.headers,
      });
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    }catch(error){
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

const loginRequests = new LoginRequests();
export default loginRequests;
